// @flow strict
import React from 'react';
import moment from 'moment';
import { Link } from 'gatsby';
import type { Edges } from '../../types';
import styles from './Feed.scss';

type Props = {
  edges: Edges
};

const Feed = ({ edges }: Props) => (
  <div className='feed'>
    {edges.map((edge) => (
      <div className='feed__item' key={edge.node.fields.slug}>
        <h2 className='feed__item-title'>
          <Link className='feed__item-title-link' to={edge.node.fields.slug}>
            {edge.node.frontmatter.title}
          </Link>
        </h2>
        <div className='feed__item-meta'>
          <time className='feed__item-meta-time'>
            {moment(edge.node.frontmatter.date).format('MMMM D, YYYY')}
          </time>
          <span className='feed__item-meta-divider' />
          <span className='feed__item-meta-category'>
            <Link to={edge.node.fields.categorySlug} className='feed__item-meta-category-link'>{edge.node.frontmatter.category}</Link>
          </span>
        </div>
        <p className='feed__item-description'>{edge.node.frontmatter.description}</p>
        <Link className='feed__item-readmore' to={edge.node.fields.slug}>
          Read<svg className="feed__item-readmore-arrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" stroke="#2ed1a3" strokeWidth="1.5" strokeLinejoin="round" strokeMiterlimit="10">
              <path className="feed__item-readmore-arrow-arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
            </g>
          </svg>
        </Link>
      </div>
    ))}
  </div>
);

export default Feed;


{/* <div className={styles['feed']}>
    {edges.map((edge) => (
      <div className={styles['feed__item']} key={edge.node.fields.slug}>
        <div className={styles['feed__item-meta']}>
          <time className={styles['feed__item-meta-time']} dateTime={moment(edge.node.frontmatter.date).format('MMMM D, YYYY')}>
            {moment(edge.node.frontmatter.date).format('MMMM YYYY')}
          </time>
          <span className={styles['feed__item-meta-divider']} />
          <span className={styles['feed__item-meta-category']}>
            <Link to={edge.node.fields.categorySlug} className={styles['feed__item-meta-category-link']}>{edge.node.frontmatter.category}</Link>
          </span>
        </div>
        <h2 className={styles['feed__item-title']}>
          <Link className={styles['feed__item-title-link']} to={edge.node.fields.slug}>{edge.node.frontmatter.title}</Link>
        </h2>
        <p className={styles['feed__item-description']}>{edge.node.frontmatter.description}</p>
        <Link className={styles['feed__item-readmore']} to={edge.node.fields.slug}>Read</Link>
      </div>
    ))}
  </div> */}